import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Pannello collassabile riutilizzabile: header cliccabile, contenuto
// espandibile/richiudibile al tap. Di default collassato (open=false).
export function CollapsibleSection({
  icon: Icon,
  iconClass = 'bg-slate-100 text-slate-700',
  title,
  subtitle,
  headerRight,
  defaultOpen = false,
  children,
}: {
  icon: React.ComponentType<{ className?: string }>;
  iconClass?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  headerRight?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="ln-card p-3.5 sm:p-5">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 text-left"
        aria-expanded={open}
      >
        <div className="flex items-center gap-2.5">
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${iconClass}`}>
            <Icon className="w-4 h-4" />
          </div>
          <div>
            <h3 className="text-sm sm:text-base font-bold text-slate-900 leading-tight mb-0">{title}</h3>
            {subtitle && (
              <div className={`text-xs mt-0.5 transition-colors ${open ? 'text-slate-500 font-medium' : 'text-slate-800 font-bold'}`}>
                {subtitle}
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {headerRight}
          <div className="w-6 h-6 rounded-md flex items-center justify-center text-slate-400 hover:text-slate-600">
            <ChevronDown
              className={`w-4 h-4 transition-transform duration-150 ${open ? 'rotate-180 text-indigo-600' : ''}`}
            />
          </div>
        </div>
      </button>

      {open && <div className="mt-3.5 pt-3.5 border-t border-slate-100/80 space-y-3 animate-fade-in">{children}</div>}
    </section>
  );
}
